import React, { useEffect, useState } from "react"
import { fabric } from "fabric"
import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react"
import { Input, Label, Button, UncontrolledTooltip } from "reactstrap"
import axios from "axios"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from 'reselect'
import { uploadDesign } from "store/actions"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

const CreateDesigns = () => {
    const navigate = useNavigate()

    const dispatch = useDispatch();

    const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const { editor, onReady } = useFabricJSEditor()
    const history = []
    const [color, setColor] = useState("#35363a")
    const [cropImage, setCropImage] = useState(true)
    const [designName, setDesign] = useState("")
    const [designDesc, setDesignDesc] = useState("")
  
    const [fontFamilyx, setFontFamily] = useState("Pacifico")
  
    useEffect(() => {
      if (!editor || !fabric) {
        return
      }
  
      if (cropImage) {
        editor.canvas.__eventListeners = {}
        return
      }
  
      if (!editor.canvas.__eventListeners["mouse:wheel"]) {
        editor.canvas.on("mouse:wheel", function (opt) {
          var delta = opt.e.deltaY
          var zoom = editor.canvas.getZoom()
          zoom *= 0.999 ** delta
          if (zoom > 20) zoom = 20
          if (zoom < 0.01) zoom = 0.01
          editor.canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom)
          opt.e.preventDefault()
          opt.e.stopPropagation()
        })
      }
  
      if (!editor.canvas.__eventListeners["mouse:down"]) {
        editor.canvas.on("mouse:down", function (opt) {
          var evt = opt.e
          if (evt.ctrlKey === true) {
            this.isDragging = true
            this.selection = false
            this.lastPosX = evt.clientX
            this.lastPosY = evt.clientY
          }
        })
      }
  
      if (!editor.canvas.__eventListeners["mouse:move"]) {
        editor.canvas.on("mouse:move", function (opt) {
          if (this.isDragging) {
            var e = opt.e
            var vpt = this.viewportTransform
            vpt[4] += e.clientX - this.lastPosX
            vpt[5] += e.clientY - this.lastPosY
            this.requestRenderAll()
            this.lastPosX = e.clientX
            this.lastPosY = e.clientY
          }
        })
      }
  
      if (!editor.canvas.__eventListeners["mouse:up"]) {
        editor.canvas.on("mouse:up", function (opt) {
          this.setViewportTransform(this.viewportTransform)
          this.isDragging = false
          this.selection = true
        })
      }
  
      editor.canvas.renderAll()
    }, [editor])
  
    const addBackgroundFromFile = event => {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = function (fileEvent) {
        const dataUrl = fileEvent.target.result
        fabric.Image.fromURL(dataUrl, image => {
          const canvasAspect = editor.canvas.width / editor.canvas.height
          const imgAspect = image.width / image.height
          let scaleFactor
  
          if (canvasAspect >= imgAspect) {
            scaleFactor = editor.canvas.width / image.width
          } else {
            scaleFactor = editor.canvas.height / image.height
          }
  
          image.set({
            scaleX: scaleFactor,
            scaleY: scaleFactor,
            left: editor.canvas.width / 2 - (image.width * scaleFactor) / 2,
            top: editor.canvas.height / 2 - (image.height * scaleFactor) / 2,
            originX: "left",
            originY: "top",
            selectable: true,
            lockMovementX: false,
            lockMovementY: false,
            lockScalingFlip: true,
          })
  
          editor.canvas.add(image)
          editor.canvas.sendToBack(image)
          editor.canvas.setActiveObject(image)
          editor.canvas.renderAll()
        })
      }
      reader.readAsDataURL(file)
    }
  
    useEffect(() => {
      if (!editor || !fabric) {
        return
      }
      editor.canvas.setHeight(400)
      editor.canvas.setWidth(400)
      editor.canvas.setBackgroundColor(
        "white",
        editor.canvas.renderAll.bind(editor.canvas)
      )
      editor.canvas.renderAll()
    }, [editor?.canvas.backgroundImage])
  
    useEffect(() => {
      if (!editor || !fabric) {
        return
      }
      editor.canvas.freeDrawingBrush.color = color
      editor.setStrokeColor(color)
    }, [color])
  
    const undo = () => {
      if (editor.canvas._objects.length > 0) {
        history.push(editor.canvas._objects.pop())
      }
      editor.canvas.renderAll()
    }
  
    const redo = () => {
      if (history.length > 0) {
        editor.canvas.add(history.pop())
      }
    }
  
    const clear = () => {
      editor.canvas._objects.splice(0, editor.canvas._objects.length)
      history.splice(0, history.length)
      editor.canvas.renderAll()
    }
  
    const removeSelectedObject = () => {
      editor.canvas.remove(editor.canvas.getActiveObject())
    }
  
    const addText = () => {
      editor.addText("Label", {
        fontFamily: "Pacifico",
      })
    }
  
    const saveDesign = async () => {
      if (designName) {
        const json = editor.canvas.toJSON()
        try {
          dispatch(uploadDesign({
            design_name: designName,
            design: json,
            description:designDesc
          }))
        } catch (error) {
          console.error("Error saving design:", error)
          toast.error("An error occurred while saving the design. Please try again.")
        }
      } else {
        toast.warning("Design Name is required!")
      }
    }

    const ManageRtoReducer = state => state.ManageMarketingToolsReducer
    const ManageRtoReducerProperty = createSelector(
        ManageRtoReducer,
        ManageRtoStore => ({
            errors: ManageRtoStore.errors,
            successMsg: ManageRtoStore.successMsg,
            Loading: ManageRtoStore.Loading,
            designList: ManageRtoStore.designList
        })
    )
    
    const { errors, successMsg, Loading, designList } =
    useSelector(ManageRtoReducerProperty)

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
           
        }
    }, [errors, successMsg])


  
    const downloadCanvas = () => {
      const dataURL = editor.canvas.toDataURL({
        format: "png",
        quality: 1,
        multiplier: 2,
        enableRetinaScaling: true,
      })
      const a = document.createElement("a")
      a.href = dataURL
      a.download = "canvas_image.png"
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  
    const centerText = () => {
      const activeObject = editor.canvas.getActiveObject()
      if (activeObject && activeObject.type === "i-text") {
        activeObject.set({
          left: editor.canvas.width / 2 - activeObject.width / 2,
          top: editor.canvas.height / 2 - activeObject.height / 2,
          originX: "left",
          originY: "top",
        })
        editor.canvas.renderAll()
      }
    }
  
    const handleFontChange = event => {
      const selectedFont = event.target.value
      setFontFamily(selectedFont)
      const activeObject = editor.canvas.getActiveObject()
      if (activeObject && activeObject.type === "i-text") {
        activeObject.set({ fontFamilyx: selectedFont })
        editor.canvas.renderAll()
      }
    }
  
    return (
      <div className="page-content" style={{ background: "#eee", minHeight: "100vh"}}>
        <div className="mb-4 d-flex justify-content-between">
            <h4>Create Design - Super Admin</h4>
            <div>
            <Button
                  onClick={() => navigate(-1)}
                  color="primary"
                  id="backBtn">
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="back-arrow"
                  />
                </Button>

                <UncontrolledTooltip
                  placement="top"
                  target={`backBtn`}
                >
                  Back
                </UncontrolledTooltip>
            </div>
        </div>
        <div className="d-flex justify-content-between" style={{ width: "100%" }}>
          <div
            style={{
              width: "400px",
              height: "400px",
              backgroundColor: "white",
            }}
          >
            <FabricJSCanvas className="sample-canvas" onReady={onReady} />
          </div>
  
          <div className="d-flex">
            <ul
              className="list-group"
              style={{ width: "200px", cursor: "pointer" }}
            >
              <li className="list-group-item cursor-pointer">
                <Label>Design Name</Label>
                <span className="text-danger">*</span>
                <Input
                  type="text"
                  placeholder="Enter Design Name"
                  value={designName}
                  onChange={e => setDesign(e.target.value)}
                />
              </li>

              <li className="list-group-item cursor-pointer">
                <Label>Design Description</Label>
                <span className="text-danger">*</span>
                <Input
                  type="textarea"
                  placeholder="Enter Design Description"
                  value={designDesc}
                  onChange={e => setDesignDesc(e.target.value)}
                />
              </li>

              <li className="list-group-item cursor-pointer">
                <Label>Select Font-family</Label>
                <select
                  className="form-select"
                  value={fontFamilyx}
                  onChange={handleFontChange}
                  aria-label="Default select example"
                >
                  <option value="Pacifico">Pacifico</option>
                  <option value="Arial">Arial</option>
                  <option value="Helvetica">Helvetica</option>
                  <option value="Times New Roman">Times New Roman</option>
                  <option value="Courier New">Courier New</option>
                  <option value="Verdana">Verdana</option>
                </select>
              </li>
            </ul>
            <ul
              className="list-group"
              style={{ width: "200px", cursor: "pointer" }}
            >
              <li className="list-group-item cursor-pointer" onClick={saveDesign}>
                Save Design
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={addText}
                disabled={!cropImage}
              >
                Label
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={clear}
                disabled={!cropImage}
              >
                Clear
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={undo}
                disabled={!cropImage}
              >
                Undo
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={redo}
                disabled={!cropImage}
              >
                Redo
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={removeSelectedObject}
                disabled={!cropImage}
              >
                Delete
              </li>
              <li
                className="list-group-item cursor-pointer"
                onClick={downloadCanvas}
              >
                Download
              </li>
  
              <li className="list-group-item cursor-pointer">
                <input
                  type="file"
                  accept="image/*"
                  onChange={addBackgroundFromFile}
                  style={{ display: "none" }}
                  id="upload-background"
                />
                <label htmlFor="upload-background" style={{ cursor: "pointer" }}>
                  Upload backgroundImage
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
}

export default CreateDesigns